<main *ngIf="event$ | async as event; else noEvent">
  <div class="event-header">
    <h1>{{ event.name }}</h1>
    <small *ngIf="organization$ | async as organization;">Aangeboden door: <u>{{ organization.name }}</u><span
      class="separator"></span>Locatie: <u>{{ event.address.location }}</u><span
      class="separator"></span>Op {{ event.start.toMillis() | date:'d MMMM' }}<span
      class="separator"></span>Duurt: {{ event.start.toDate().valueOf() | timeDifference:event.end.toDate().valueOf() }}</small>
  </div>
  <div class="gallery-holder">
    <div *ngIf="event.images.length > 1" class="all-button" (click)="openModal(302, 0)">Bekijk alle {{ event.images.length }} afbeeldingen</div>
    <div *ngIf="event.images.length == 1" class="all-button" (click)="openModal(302, 0)">Afbeelding vergroten</div>
    <div class="gallery">
      <div>
        <img [src]="event.images[0]" alt="">
      </div>
    </div>
  </div>
  <div class="event-details" *ngIf="organization$ | async as organization;">
    <div class="info">
      <h2>Beschrijving</h2>
      <p class="description">{{ event.description }}</p>
      <h2 class="mt-4">Algemene informatie</h2>
      <div class="general-information p-2">
        <div class="group">
          <div class="section">
            <div class="holder"><i class="bi bi-geo-alt-fill"></i>
              <div class="title"><p>Locatie</p></div>
            </div>
            <p class="text">{{ event.address.location }}</p>
          </div>
          <div class="section">
            <div class="holder"><i class="bi bi-calendar-event-fill"></i>
              <div class="title"><p>Datum</p></div>
            </div>
            <p class="text">{{ event.start.toMillis() | date:'d MMMM' }}</p>
          </div>
          <div class="section">
            <div class="holder"><i class="bi bi-clock-fill"></i>
              <div class="title"><p>Start- en eindtijd</p></div>
            </div>
            <p class="text">{{ event.start.toMillis() | date:'H:mm' }}
              - {{ event.end.toMillis() | date:'H:mm' }}</p>
          </div>
        </div>
        <div class="group">
          <div class="section">
            <div class="holder"><i class="bi bi-ui-checks"></i>
              <div class="title"><p>Toegankelijk voor</p></div>
            </div>
            <p class="text"><span class="tag" *ngFor="let tag of event.accessibility.getDescriptions('short')"> {{ tag }} </span></p>
          </div>
          <div class="section">
            <div class="holder"><i class="bi bi-tags-fill"></i>
              <div class="title"><p>Categorie</p></div>
            </div>
            <p class="text">{{event.category}}</p>
          </div>
        </div>
        <button *ngIf="!user || !user.superAdmin && !user.organization || !user.superAdmin && user.organization.path != 'organizations/' + organization.id" [ngClass]="{'signed-up': signedUp}" class="signup-button hide-desktop" (click)="presentSignUpModal(event.id)">
          {{ signedUp ? 'Afmelden' : 'Aanmelden' }}
        </button>
        <button *ngIf="user && ((user.organization && user.organization.path == 'organizations/' + organization.id) || user.superAdmin)" class="edit-button hide-desktop" (click)="editEvent(event.id)">
          Activiteit aanpassen
        </button>
        <button *ngIf="user && ((user.organization && user.organization.path == 'organizations/' + organization.id) || user.superAdmin)" class="delete-button hide-desktop" (click)="presentDeleteModal(event.id)">
          Activiteit verwijderen
        </button>
      </div>
      <h2 *ngIf="event.parts[0].name != null">Planning</h2>
      <div class="planning" *ngIf="event.parts[0].name != null">
        <div class="activity" *ngFor="let activity of event.parts">
          <p>{{ activity.start }} - {{ activity.end }}</p>
          <p class="fw-bold"><span class="vl me-3"></span>{{ activity.name }}</p>
        </div>
      </div>
    </div>
    <div class="org">
      <button *ngIf="!user || !user.superAdmin && !user.organization || !user.superAdmin && user.organization.path != 'organizations/' + organization.id" [ngClass]="{'signed-up': signedUp}" class="signup-button hide-mobile" (click)="presentSignUpModal(event.id)">
        {{ signedUp ? 'Afmelden' : 'Aanmelden' }}
      </button>
      <button *ngIf="user && ((user.organization && user.organization.path == 'organizations/' + organization.id) || user.superAdmin)" class="edit-button hide-mobile" (click)="editEvent(event.id)">
        Activiteit aanpassen
      </button>
      <button *ngIf="user && ((user.organization && user.organization.path == 'organizations/' + organization.id) || user.superAdmin)" class="delete-button hide-mobile" (click)="presentDeleteModal(event.id)">
        Activiteit verwijderen
      </button>
      <div class="info mt-2">
        <div class="p-2">
          <div class="header">
            <img src="{{ organization.picture || 'assets/img/profile-picture.png' }}" [width]="90"
                 [height]="90"
                 alt="Profielfoto Organisatie">
            <div class="details">
              <h2>{{ organization.name }}</h2>
              <div>
                <p>{{ organization.email }}</p>
                <p>{{ organization.contactPhone }}</p>
              </div>
            </div>
          </div>
          <p class="mt-4">{{ organization.description }}</p>
        </div>
      </div>
      <div class="info mt-2" *ngIf="organization$ | async as organization;">
        <h2 class="location-title m-0">Activiteit locatie</h2>
        <div id="map" class="map-container" #googleMap></div>
      </div>
    </div>
  </div>
</main>
<ng-template #noEvent>
  <div class="error-container my-5">
    <img class="error-container-img mb-5" src="assets/img/logo-zonder-tekst.jpg">
    <div class="error-container-text mb-5">
      <h1 class="error-header mb-3"><i>Oeps! Er is iets fout gegaan!</i></h1>
      <p>
        We hebben ons best gedaan, maar het lijkt erop dat deze activiteit helaas niet (meer) bestaat.
      </p>
      <p>
        Je kunt de huidige activiteiten vinden op het activiteiten overzicht of de homepage!
      </p>
      <button type="button" class="btn btn-back mt-2" tabindex="0" [routerLink]="['/activiteiten']">Terug naar
        activiteiten
      </button>
    </div>
  </div>
</ng-template>
